(function () {
    'use strict';

    function toggle() {
        return {
            restrict: 'C',
            scope: {
                'collapsedClass': '@',
                'expandedClass': '@'
            },
            link: function (scope, element, attrs) {
                var collapsedClass = scope.collapsedClass || 'glyphicon-chevron-down';
                var expandedClass = scope.expandedClass || 'glyphicon-chevron-right';
                element.on("click", function () {
                    var toggleContent = element.parent().children('.toggleContent').first();
                    if (toggleContent.is(':hidden')) {
                        element.find('span').first().removeClass(collapsedClass);
                        element.find('span').first().addClass(expandedClass);
                        toggleContent.show();
                    } else {
                        element.find('span').first().addClass(collapsedClass);
                        element.find('span').first().removeClass(expandedClass);
                        toggleContent.hide();
                    }
                });
            }
        };
    }

    toggle.$inject = [];

    angular.module('ecap.common').directive('toggle', toggle);
})();